import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { UserDetails } from "../models/pustakalay_model";

@Injectable({
  providedIn: 'root'
})
export class LoginService {
  public isAuthenticated: boolean = false;

  constructor(private http: HttpClient) {}

  public loginUser(l_userDetails: UserDetails) {
    let l_url = `${environment.ROOT_URL}/signup`;
    return this.http.post(l_url, l_userDetails, { responseType: 'text', observe: 'response' });
  }

  public isAuthenticatedUser(): boolean {
    // console.log('system_params from authFunc ===> ', sessionStorage.getItem('system_params'));
    // if (sessionStorage.getItem('system_params') === null) {
    //   this.isAuthenticated = false;
    // }
    // else if (sessionStorage.getItem('system_params') !== null) {
    //   this.isAuthenticated = true;
    // }
    // console.log('this.isAuthenticated before response ===> ', this.isAuthenticated);
  const token = sessionStorage.getItem('auth_token');

  // basic check: token exists
  if (!token) {
    return false;
  }

  // OPTIONAL: check token expiry (recommended)
  if (this.isJwt(token)) {
      try {
        const payload = JSON.parse(atob(token.split('.')[1]));
        if (payload.exp * 1000 > Date.now()) {
          return true;
        }
        this.logout();
        return false;
      } catch {
        return false;
      }
    }

    // ✅ NON-JWT token → just trust existence
    return true;
  }

  private isJwt(token: string): boolean {
    return token.split('.').length === 3;
  }

  public logout(): void {
    sessionStorage.clear();
  }
}
